// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.org-description {
    background-color: whitesmoke;
    padding: 10px;
    margin-bottom: 30px;
    margin-top: -4px;
    border: 1px solid lightgray;
    border-radius: 4px;
    overflow-wrap: anywhere;
    white-space: pre-wrap;
}`, "",{"version":3,"sources":["webpack://./src/pages/homeDashboard/components/Modals/ConfirmationModal/ConfirmationModal.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,2BAA2B;IAC3B,kBAAkB;IAClB,uBAAuB;IACvB,qBAAqB;AACzB","sourcesContent":[".org-description {\n    background-color: whitesmoke;\n    padding: 10px;\n    margin-bottom: 30px;\n    margin-top: -4px;\n    border: 1px solid lightgray;\n    border-radius: 4px;\n    overflow-wrap: anywhere;\n    white-space: pre-wrap;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
